var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwesomeStarLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75328 9.72342L5.2675 8.44622L2.83464 9.7627C2.73487 9.81517 2.6225 9.83895 2.51003 9.83139C2.39755 9.82383 2.28938 9.78522 2.19753 9.71986C2.10568 9.65451 2.03375 9.56496 1.98975 9.46118C1.94574 9.35739 1.93137 9.24344 1.94825 9.13198L2.3624 6.38032L0.332649 4.45098C0.250274 4.37443 0.19104 4.27629 0.161686 4.16773C0.132334 4.05918 0.13404 3.94456 0.166611 3.83692C0.199183 3.72929 0.261312 3.63296 0.345929 3.55889C0.430547 3.48482 0.534254 3.43599 0.645253 3.41796L3.38759 2.99475L4.56605 0.482622C4.61478 0.381371 4.6909 0.295799 4.78578 0.235608C4.88066 0.175418 4.99051 0.143017 5.10287 0.142079C5.21523 0.141143 5.32561 0.171707 5.42148 0.230307C5.51736 0.288907 5.59489 0.3732 5.6453 0.473623L6.92486 2.9646L9.68177 3.34222C9.79347 3.35743 9.89876 3.4033 9.98595 3.47476C10.0731 3.54622 10.1388 3.64045 10.1756 3.74699C10.2125 3.85353 10.2191 3.9682 10.1946 4.07825C10.1702 4.1883 10.1158 4.28942 10.0373 4.37038L8.08799 6.33464L8.61428 9.07883C8.63644 9.18919 8.62688 9.30357 8.58671 9.40872C8.54653 9.51387 8.47738 9.60548 8.38727 9.67294C8.29716 9.7404 8.18979 9.78095 8.07758 9.78988C7.96537 9.79882 7.85293 9.77577 7.75328 9.72342Z",
    fill: "#FFE3B2",
    stroke: "#CB8100",
    strokeWidth: 0.283637
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwesomeStarLight);
export default __webpack_public_path__ + "static/media/awesome-star-light.564db2769c06560484c952757c1f4fcf.svg";
export { ForwardRef as ReactComponent };